export default {
  name: 'TechLoading',
  props: {
    size: {
      type: Number,
      default: 100
    },
    text: {
      type: String,
      default: ''
    }
  }
};
export const techLoadingSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120">
  <defs>
    <radialGradient id="tlBallGlow">
      <stop offset="0%" stop-color="#ffffff"/>
      <stop offset="40%" stop-color="#66b1ff"/>
      <stop offset="100%" stop-color="rgba(0,116,252,0)"/>
    </radialGradient>
    <linearGradient id="tlArcGrad" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#4A9DFF"/>
      <stop offset="100%" stop-color="#0074FC"/>
    </linearGradient>
    <radialGradient id="tlBg" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="rgba(0,116,252,0.14)"/>
      <stop offset="100%" stop-color="rgba(0,116,252,0)"/>
    </radialGradient>
  </defs>
  <circle cx="60" cy="60" r="59" fill="url(#tlBg)"/>
  <g>
    <animateTransform attributeName="transform" type="rotate" from="0 60 60" to="360 60 60" dur="24s" repeatCount="indefinite"/>
    <circle cx="60" cy="60" r="54" fill="none" stroke="rgba(0,116,252,.55)" stroke-width="2.8" stroke-dasharray="2 5"/>
  </g>
  <circle cx="60" cy="60" r="33" fill="none" stroke="rgba(0,116,252,.4)" stroke-width="1.2" stroke-dasharray="3 4"/>
  <g>
    <animateTransform attributeName="transform" type="rotate" from="360 60 60" to="0 60 60" dur="5s" repeatCount="indefinite"/>
    <circle cx="60" cy="60" r="33" fill="none" stroke="#0074FC" stroke-width="2" stroke-linecap="round" stroke-dasharray="52 155.3"/>
  </g>
  <g>
    <animateTransform attributeName="transform" type="rotate" from="0 60 60" to="360 60 60" dur="2.5s" repeatCount="indefinite"/>
    <circle cx="60" cy="60" r="44" fill="none" stroke="url(#tlArcGrad)" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="200 76.5"/>
    <circle cx="60" cy="60" r="44" fill="none" stroke="rgba(0,116,252,.3)" stroke-width="1" stroke-dasharray="60 216.5" transform="rotate(120 60 60)"/>
    <circle cx="32" cy="94" r="4" fill="url(#tlBallGlow)"/>
    <circle cx="32" cy="94" r="2" fill="#ffffff"/>
  </g>
  <circle cx="60" cy="60" r="10" fill="url(#tlBallGlow)">
    <animate attributeName="r" values="10;14;10" dur="2.5s" repeatCount="indefinite"/>
  </circle>
  <circle cx="60" cy="60" r="3.5" fill="#ffffff">
    <animate attributeName="r" values="3.5;5;3.5" dur="2.5s" repeatCount="indefinite"/>
  </circle>
  <g stroke="#ffffff" stroke-linecap="round">
    <line x1="60" y1="48" x2="60" y2="54" stroke-width="1.2" opacity=".9">
      <animate attributeName="opacity" values="0.3;1;0.3" dur="1.4s" repeatCount="indefinite"/>
    </line>
    <line x1="60" y1="66" x2="60" y2="72" stroke-width="1.2" opacity=".9">
      <animate attributeName="opacity" values="0.3;1;0.3" dur="1.4s" begin="0.35s" repeatCount="indefinite"/>
    </line>
    <line x1="48" y1="60" x2="54" y2="60" stroke-width="1.2" opacity=".9">
      <animate attributeName="opacity" values="0.3;1;0.3" dur="1.4s" begin="0.7s" repeatCount="indefinite"/>
    </line>
    <line x1="66" y1="60" x2="72" y2="60" stroke-width="1.2" opacity=".9">
      <animate attributeName="opacity" values="0.3;1;0.3" dur="1.4s" begin="1.05s" repeatCount="indefinite"/>
    </line>
  </g>
  <rect x="50" y="50" width="20" height="20" fill="none" stroke="#0074FC" stroke-width="1.8" transform="rotate(45 60 60)"/>
</svg>`;